import axios, {AxiosResponse} from "axios";
let baseURL = process.env.REACT_APP_BASE_URL;

export const walletServices = {
    pdlList
}

async function pdlList(limit = 1000, offset = 0, colonyId = 0){

    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.get(`${baseURL}clients?offset=${offset}&limit=${limit}&colony=${colonyId}`,config);
}